
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private label: any;
  @Prop()
  private filters: any;
  @Watch("filters", { immediate: true })
  private filtersChange() {
    this.data = JSON.parse(JSON.stringify(this.filters));
  }
  private data: any = {};
  private disabledStartDate: any = this.beginDate();
  private disabledEndDate: any = this.endDate();
  private beginDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        if (self.data.endTime) {
          return (
            time.getTime() > new Date(self.data.endTime).getTime() ||
            time.getTime() > Date.now()
          );
        } else {
          return time.getTime() > Date.now();
        }
      },
    };
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        if (self.data.startTime) {
          return (
            new Date(self.data.startTime).getTime() > time.getTime() ||
            time.getTime() > Date.now()
          );
        } else {
          return time.getTime() > Date.now();
        }
      },
    };
  }
  private search() {
    this.$emit("search",this.data);
  }
}
